/* ═══════════════════════════════════════════════════════════
   DARF — Animations: JS class flag + IntersectionObserver
   Must load early — adds .js class to <html> which enables
   fade-up CSS animations (hidden by default without JS).
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* Signal to CSS that JS is running — unlocks .js .fade-up rules */
  document.documentElement.classList.add('js');

  /* ── Scroll fade-in ─────────────────────────────────────── */
  if (!('IntersectionObserver' in window)) {
    /* Fallback: show everything immediately */
    document.querySelectorAll('.fade-up').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  /* Observe all fade-up elements present at load time */
  document.querySelectorAll('.fade-up').forEach(function (el) {
    io.observe(el);
  });

  /* Allow other modules to observe newly added elements */
  window.DarfObserver = io;
})();
